import { Theme } from '@emotion/react';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

export function useThemeMediaQuery(query: (theme: Theme) => string) {
  const theme = useTheme();
  return useMediaQuery(query(theme));
}

/**
 * returns true if breakpoints.up('md') is true
 */
export function useIsLargeUpScreen() {
  return useThemeMediaQuery(({ breakpoints: { up } }) => up('md'));
}

/**
 * returns true if breakpoints.down('md') is true
 */
export function useIsMediumScreen() {
  // In Mui v4 there's a bug https://github.com/mui/material-ui/issues/17875
  // Long story short: to get md, set it to small, ie one breakpoint down.
  // Change this for Mui V5.
  return useThemeMediaQuery(({ breakpoints: { down } }) => down('sm'));
}

/**
 * returns true if breakpoints.down('sm') is true
 */
export function useIsSmallScreen() {
  // In Mui v4 there's a bug https://github.com/mui/material-ui/issues/17875
  // Long story short: to get sm, set it to xs, ie one breakpoint down.
  // Change this for Mui V5.
  return useThemeMediaQuery(({ breakpoints: { down } }) => down('xs'));
}

/**
 * returns true if breakpoints.down('md') is true and breakpoints.down('sm') is false
 */
export function useIsOnlyMediumScreen() {
  const isSmallScreen = useIsSmallScreen();
  const isMediumScreen = useIsMediumScreen();

  return isMediumScreen && !isSmallScreen;
}
